export default {
  // 获取手机验证码
  getAuthCode: '/amc/client/getAuthCode',
  // 获取用户信息
  getMemberByToken: '/amc/client/getMemberByToken',
  // 点击访问量
  clickPlayCount: '/amc/client/statistics/clickPlayCount',
  // 增加积分
  addScore: '/amc/client/unifiedScore',

    /* 评论相关接口，适用于以下类型 */
  /* contentType 内容类型：*/
  /* 1:图文资讯 2:图集 3:广告 4:专题 5:活动 6:投票调查 7:直播 8:抽奖 9:视频 */
  // 评论列表接口(评论回复列表接口)
  getCommentListByNewsId: '/amc/client/listCommentsWithChildsByContentIdAndTypeAndParentId',
  // 评论列表接口（直播间评论、最新报料评论、最热报料评论）
  getCommentListById: "/amc/client/newListCommentByContentIdAndType",
  // 新增评论
  addComment: '/amc/client/addCommentData',

  /* 点赞相关接口，适用于以下类型 */
  /* contentType 内容类型：*/
  /* 1:活动 2:抽奖 3:投票调查 4:直播间 5:图文资讯 6:图集 7:专题 8:占位广告 9:视频 11:音频 12:外链 16:报料 */
  // 查询点赞状态接口
  queryThumbsUpStatus: '/amc/client/findUserLikesByContentIdAndMemberOrDeviceId',
  // 点赞接口
  giveThumbsUp: '/amc/client/addTopDataByContent',
  // 取消点赞接口
  cancelThumbsUp: '/amc/client/deleteTopDataByContent',
  // 评论点赞
  giveThumbsUpComment: '/amc/client/addTopDataComment',

  /* 收藏 */
  addMemberCollect: '/amc/client/addMemberCollect',
  /* 取消收藏 */
  cancelMemberCollect: '/amc/client/cancelMemberCollect',
  /* 获取微信Ticket */
  getWeiXinTicket: '/amc/client/getWeiXinTicket',
}